var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpatialMapping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_59998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.743 94.1799C113.264 93.4917 112.666 92.5342 111.933 91.6665C110.571 90.0207 109.15 88.4049 107.698 86.8191C107.399 86.4899 106.816 86.071 106.471 86.1608C102.97 87.0135 99.4689 87.8663 96.0275 88.9435C94.7706 89.3325 94.8305 90.2003 96.1023 90.7987C97.2993 91.3672 98.5562 91.8011 99.813 92.1751C104.571 93.5815 109.449 94.1201 113.728 94.1799H113.743ZM119.429 94.2547C121.329 94.1201 123.334 94.165 125.264 93.7909C129.244 93.0129 133.195 92.0255 137.145 91.0381C137.683 90.9034 138.102 90.2451 138.581 89.8262C138.102 89.4223 137.668 88.7939 137.115 88.6293C133.988 87.7466 130.845 86.9088 127.658 86.2056C127.15 86.086 126.312 86.5498 125.908 86.9836C123.738 89.3325 121.643 91.7413 119.444 94.2547H119.429Z",
    fill: "url(#paint0_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0299 59.4255V45.9007C27.3192 45.9007 29.5935 45.9605 31.8678 45.8558C32.616 45.8259 33.6334 45.5566 34.0224 45.018C34.4863 44.3896 34.7556 43.1777 34.4414 42.5494C34.0973 41.8312 33.0499 41.1131 32.2419 41.0533C29.9077 40.8588 27.5436 40.9785 25.1197 40.9785C25.0748 40.6044 25 40.3202 25 40.0359C25 35.8468 25 31.6427 25 27.4536C25 25.6583 25.6284 25 27.3791 25C34.8005 25 42.2219 25 49.6434 25C51.4838 25 52.0374 25.6433 52.0374 27.7229C52.0374 42.3698 52.0374 57.0168 52.0374 71.6637C52.0374 104.234 52.0374 136.804 52.0374 169.375C52.0374 172.113 51.6484 172.501 48.9701 172.501C41.8479 172.501 34.7406 172.501 27.6185 172.501C25.5536 172.501 25 171.948 25 169.853C25 165.455 25 161.071 25 156.523C27.3192 156.523 29.5037 156.523 31.6883 156.523C33.6035 156.523 34.7556 155.566 34.7556 154.054C34.7556 152.558 33.5885 151.616 31.6733 151.601C29.5337 151.601 27.3791 151.601 25.1197 151.601V138.076C28.0524 138.076 31 138.076 33.9476 138.076C36.5062 138.076 37.5985 137.343 37.6135 135.637C37.6135 133.917 36.5062 133.169 33.9626 133.169C31.0449 133.169 28.1272 133.169 25.1047 133.169V119.644C27.2743 119.644 29.4589 119.644 31.6434 119.644C33.5736 119.644 34.7257 118.716 34.7556 117.22C34.7855 115.709 33.6035 114.737 31.7032 114.737C29.5187 114.737 27.3342 114.737 25.0599 114.737V101.212C27.02 101.212 28.995 101.212 30.9701 101.212C32.2569 101.212 33.5287 101.227 34.8155 101.212C36.5362 101.182 37.5686 100.284 37.5985 98.8181C37.6284 97.2771 36.581 96.3345 34.7556 96.3046C32.0474 96.2747 29.3242 96.3046 26.616 96.3046C26.1222 96.3046 25.6284 96.3046 25.0449 96.3046V82.7798C27.2294 82.7798 29.399 82.7798 31.5835 82.7798C33.5287 82.7798 34.6808 81.8971 34.7257 80.401C34.7855 78.845 33.5736 77.8725 31.5686 77.8725C29.4289 77.8725 27.2893 77.8725 25.0599 77.8725V64.3477C25.7481 64.3477 26.4963 64.3477 27.2294 64.3477C29.788 64.3477 32.3466 64.3776 34.9052 64.3477C36.596 64.3327 37.6135 63.3303 37.5835 61.8342C37.5536 60.4279 36.5511 59.4704 34.9352 59.4405C31.6733 59.4105 28.3965 59.4405 25 59.4405L25.0299 59.4255Z",
    fill: "url(#paint1_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3492 88.9134C93.1546 110.592 110.87 132.181 128.751 153.934H63.1995V152.259C63.1995 135.727 63.1995 119.18 63.1846 102.648C63.1846 101.541 63.4689 100.748 64.2768 99.9547C67.9726 96.3491 71.5935 92.6686 75.3641 88.8984L75.3492 88.9134Z",
    fill: "url(#paint2_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.531 81.5828C131.683 80.1016 132.79 78.8449 133.733 77.4685C135.933 74.2668 138.012 70.9903 140.212 67.7737C140.526 67.3249 141.17 66.8311 141.678 66.8012C144.491 66.7115 147.304 66.7563 150.372 66.7563C150.372 67.3548 150.372 67.8784 150.372 68.417C150.372 79.7426 150.371 91.0532 150.342 102.379C150.342 103.067 150.117 103.95 149.653 104.413C139.703 114.452 129.693 124.431 119.698 134.425C119.623 134.5 119.534 134.545 119.294 134.725C105.828 118.327 92.3615 101.93 79.0149 85.6672C84.3117 80.3709 89.5037 75.1645 94.6209 70.0328C97.359 73.7881 100.172 77.648 103.03 81.5828C101.16 82.1064 99.3191 82.4954 97.5685 83.1387C96.0423 83.6923 94.5161 84.3805 93.1845 85.2782C89.1146 88.0011 89.1146 91.8461 93.2742 94.4643C95.2343 95.6911 97.4787 96.6037 99.7082 97.2171C107.608 99.3715 115.688 99.6408 123.783 98.8778C127.928 98.4888 132.057 97.5762 136.112 96.5589C137.982 96.0801 139.808 95.0029 141.349 93.806C144.401 91.4272 144.461 88.2106 141.349 85.9664C139.239 84.4553 136.666 83.5726 134.242 82.5403C133.15 82.0765 131.908 81.9419 130.546 81.5978L130.531 81.5828Z",
    fill: "url(#paint3_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.825 89.7514C114.372 86.9387 112.067 84.3355 109.808 81.7023C104.87 75.9423 100.142 70.0626 96.7306 63.2104C89.6683 49.0871 99.1097 33.7669 112.726 31.448C121.733 29.9219 129.304 32.7197 134.84 40.0057C140.302 47.202 140.93 55.0716 136.98 63.2702C133.733 70.0327 129.02 75.7628 124.217 81.4181C122.257 83.7221 120.267 85.9812 118.277 88.2553C117.888 88.7041 117.454 89.123 116.855 89.7514H116.825ZM116.855 39.0482C108.79 39.0482 102.342 45.4964 102.282 53.5605C102.237 61.6245 108.82 68.2523 116.885 68.2373C124.905 68.2224 131.399 61.7292 131.459 53.6951C131.519 45.6161 124.98 39.0482 116.855 39.0632V39.0482Z",
    fill: "url(#paint4_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.312 111.281V154.099C148.875 154.099 147.469 154.099 146.047 154.099C142.771 154.099 139.494 154.114 136.232 154.069C135.738 154.069 135.065 153.89 134.781 153.531C130.696 148.624 126.656 143.671 122.721 138.884C131.968 129.623 141.14 120.452 150.312 111.266V111.281Z",
    fill: "url(#paint5_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.646 169.659H70.576C71.0848 170.107 71.4588 170.407 71.7731 170.721C72.7755 171.723 72.8653 173.01 72.0424 174.042C71.2194 175.074 69.8878 175.344 68.7506 174.491C66.3267 172.696 63.9476 170.84 61.6135 168.91C60.4164 167.923 60.4314 166.262 61.6284 165.275C63.9626 163.36 66.3416 161.49 68.7656 159.694C69.8429 158.901 71.01 159.081 71.9526 160.068C72.8504 161.026 72.7905 162.372 71.8479 163.39C71.5486 163.719 71.1895 164.003 70.6658 164.482H146.317C146.421 164.392 146.511 164.302 146.616 164.198C146.212 163.928 145.748 163.719 145.419 163.39C144.476 162.402 144.387 161.265 145.195 160.188C146.017 159.111 147.244 158.827 148.322 159.605C150.85 161.43 153.304 163.36 155.698 165.365C156.85 166.337 156.805 167.878 155.623 168.866C153.304 170.796 150.925 172.651 148.501 174.446C147.364 175.299 146.032 175.03 145.209 174.012C144.416 173.025 144.521 171.648 145.494 170.676C145.808 170.362 146.137 170.077 146.631 169.614L146.646 169.659Z",
    fill: "url(#paint6_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.658 146.648C170.137 146.14 170.451 145.736 170.825 145.407C171.798 144.554 172.89 144.464 173.908 145.227C174.985 146.035 175.374 147.232 174.566 148.339C172.711 150.912 170.766 153.426 168.716 155.834C167.698 157.046 166.127 156.792 165.005 155.416C163.269 153.276 161.564 151.092 159.903 148.878C158.93 147.591 159.035 146.199 160.082 145.317C161.175 144.389 162.566 144.584 163.718 145.84C163.913 146.05 164.107 146.259 164.481 146.678V76.8099C163.973 77.3635 163.673 77.7375 163.314 78.0666C162.297 78.9793 161.175 79.0541 160.112 78.1863C159.11 77.3784 158.811 76.1965 159.559 75.1642C161.414 72.5909 163.374 70.0924 165.394 67.6537C166.277 66.5915 167.908 66.6364 168.806 67.7136C170.766 70.0774 172.651 72.5011 174.476 74.9697C175.299 76.0918 175 77.4682 173.938 78.2312C172.816 79.0391 171.723 78.8895 170.736 77.9918C170.407 77.6926 170.137 77.3036 169.658 76.7351V146.633V146.648Z",
    fill: "url(#paint7_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3342 66.8164H90.1023C90.222 66.9511 90.3417 67.0857 90.4614 67.2204C81.4539 76.0324 72.4614 84.8445 63.3342 93.7763V66.8164Z",
    fill: "url(#paint8_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.743 94.1799C109.464 94.1201 104.586 93.5665 99.8279 92.1751C98.5561 91.8011 97.2992 91.3672 96.1172 90.7987C94.8454 90.2003 94.7855 89.3325 96.0424 88.9435C99.4838 87.8663 102.985 87.0135 106.486 86.1608C106.83 86.071 107.414 86.4899 107.713 86.8191C109.165 88.4049 110.571 90.0058 111.948 91.6665C112.666 92.5342 113.264 93.5067 113.758 94.1799H113.743Z",
    fill: "url(#paint9_linear_121_59998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.429 94.2699C121.643 91.7714 123.723 89.3477 125.893 86.9988C126.297 86.5499 127.135 86.1011 127.643 86.2208C130.816 86.924 133.958 87.7618 137.1 88.6445C137.653 88.8091 138.087 89.4225 138.566 89.8414C138.087 90.2603 137.683 90.9186 137.13 91.0532C133.195 92.0407 129.244 93.0281 125.249 93.8061C123.319 94.1801 121.314 94.1352 119.414 94.2699H119.429Z",
    fill: "url(#paint10_linear_121_59998)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_59998",
    x1: 116.849,
    y1: 86.1484,
    x2: 116.849,
    y2: 94.2547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_59998",
    x1: 38.5187,
    y1: 25,
    x2: 38.5187,
    y2: 172.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_59998",
    x1: 95.9676,
    y1: 88.8984,
    x2: 95.9676,
    y2: 153.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_59998",
    x1: 114.693,
    y1: 66.7451,
    x2: 114.693,
    y2: 134.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_59998",
    x1: 116.921,
    y1: 31.0449,
    x2: 116.921,
    y2: 89.7514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_121_59998",
    x1: 136.516,
    y1: 111.266,
    x2: 136.516,
    y2: 154.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_121_59998",
    x1: 108.63,
    y1: 159.163,
    x2: 108.63,
    y2: 174.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_121_59998",
    x1: 167.069,
    y1: 66.8809,
    x2: 167.069,
    y2: 156.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_121_59998",
    x1: 76.8978,
    y1: 66.8164,
    x2: 76.8978,
    y2: 93.7763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_121_59998",
    x1: 104.444,
    y1: 86.1484,
    x2: 104.444,
    y2: 94.1799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_121_59998",
    x1: 128.99,
    y1: 86.2012,
    x2: 128.99,
    y2: 94.2699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_59998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpatialMapping);
export default __webpack_public_path__ + "static/media/Spatial_Mapping.f592381f0b471600d3f2412510c2324a.svg";
export { ForwardRef as ReactComponent };